import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  storageRowList01ResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  storageRowList01GoToDocument: ['hdrId'],
  storageRowList01FetchStorageRowList01: ['currentPage', 'sorts', 'filters', 'pageSize'],
  storageRowList01FetchStorageRowList01Loading: ['boolean'],
  storageRowList01FetchStorageRowList01Success: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  storageRowList01AddSelectedDocuments: ['selectedDocuments'],
  storageRowList01RemoveSelectedDocuments: ['selectedDocuments'],
  storageRowList01SetWorkspaceVisible: ['boolean']
});

export const StorageRowList01Types = Types;
export default Creators;
